import { QRCodeSVG } from "qrcode.react";
import Button from "../Button";
import Icon from "../icons/Icon";
import { beitrittsLink, useTeilen } from "../QrKarte";
import Sheet from "../Sheet";
import "./RaumDialog.css";

/**
 * Raumcode und QR gross — zum Herumzeigen, wenn jemand mitten im Spiel
 * dazukommt.
 */
export function RaumDialog({ code, onClose }) {
  const [kopiert, teilen] = useTeilen(code);
  return (
    <Sheet
      titel="Mitspielen"
      mitX
      onClose={onClose}
      fuss={
        <Button variant="neben" onClick={teilen}>
          <Icon name={kopiert ? "check" : "teilen"} />
          {kopiert ? "Link kopiert" : "Link teilen"}
        </Button>
      }
    >
      <div className="qr-gross">
        <div className="qr-gross-bild">
          <QRCodeSVG value={beitrittsLink(code)} size={204} level="M" />
        </div>
        <b>{code}</b>
        <span>{window.location.host}</span>
      </div>
      <p className="sheet-hinweis qr-gross-hinweis">Neue Leute scannen den Code und steigen in der nächsten Runde ein.</p>
    </Sheet>
  );
}

export default RaumDialog;
